
window.APP_RUNTIME_ENV_VARIABLES = {
  REACT_APP_ACCOUNTS_ORIGIN: "$REACT_APP_ACCOUNTS_ORIGIN",
	REACT_APP_ACCOUNTS_TOKEN_GETTER: "$REACT_APP_ACCOUNTS_TOKEN_GETTER",
	REACT_APP_API_URL: "$REACT_APP_API_URL",
	REACT_APP_CLIENT_ID: "$REACT_APP_CLIENT_ID",
	REACT_APP_YANDEX_METRIKA_COUNTER_ID: "$REACT_APP_YANDEX_METRIKA_COUNTER_ID",
	REACT_APP_FILES_STORAGE_URL: "$REACT_APP_FILES_STORAGE_URL",
	REACT_APP_REPORT_SERVICE_URL: "$REACT_APP_REPORT_SERVICE_URL",
	REACT_APP_SECURITY_SERVICE: "$REACT_APP_SECURITY_SERVICE",
	REACT_APP_NOTIFICATION_API_URL: "$REACT_APP_NOTIFICATION_API_URL",
	REACT_APP_WS_URL: "$REACT_APP_WS_URL",
	REACT_APP_4SIDES_ORIGIN: "$REACT_APP_4SIDES_ORIGIN",
	REACT_APP_API_ORIGIN: "$REACT_APP_API_ORIGIN",
	REACT_APP_LOGO_TOP_BAR_NAME: "$REACT_APP_LOGO_TOP_BAR_NAME",
	REACT_APP_CUSTOM_LOGO_URL: "$REACT_APP_CUSTOM_LOGO_URL"
};
  